<template>
    <new-vuestic-modal ref="presenca" v-bind:small="false" :cancelClass="'none'" okClass="none" :closeIconShown="false">
        <div slot="title">Verificação de Presença</div>
        <div slot="body">
            <div class="container">
                <div class="row">
                    <video class="col-6 webCam" autoplay="true" ref="webCamera"></video>
                    <img class="col-6 img-canvas" ref="picturetaken"/>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button type="button" class="btn-primary btnmodal" @click="takePicture()"><i class="fa fa-camera"></i>Capturar</button>
        </div>
    </new-vuestic-modal>
</template>
<script>

export default {
    name: 'selfie-prompt',
    data: () => {
        return {
            agrupamento: null,
            pictureData: null,
            horarios: []
        }
    },
    mounted () {
        this.agrupamento =  JSON.parse(sessionStorage.getItem('agrupamento'))
        if(localStorage.id_role == 4) {
            let dataInicio = new Date(this.agrupamento.data_inicio.replace(' ', 'T'))
            let dataFim = new Date(this.agrupamento.data_fim.replace(' ', 'T'))
            let qtdAulas = Math.floor((dataFim.getTime() - dataInicio.getTime()) / (45 * 60000))
            let currentTime = dataInicio
            currentTime.setMinutes(currentTime.getMinutes() + 20)
            this.horarios.push(currentTime)
            for (let i = 0; i < qtdAulas - 1; i++) {
                //let deltaTime = Math.floor(Math.random() * 5 + 43) * 60000
                let deltaTime = 45 * 60000
                if (i == 1) {
                    deltaTime += 15 * 60000
                }
                let time = new Date(currentTime.getTime() + deltaTime)
                currentTime = time
                this.horarios.push(time)

            }
            console.log(this.horarios)
            this.timeSpawn()
        }
    },
    methods: {
        timeSpawn(){
            let t = Date.now()
            let foundTimeIndex = this.horarios.findIndex((element) => {
                return t < element
            })
            if(foundTimeIndex >= 0) {
                setTimeout(() => {
                    this.clearPhoto();
                    this.loadCamera();
                    this.$refs.presenca.open('');
                }, (this.horarios[foundTimeIndex].getTime() - t));
            }
        },
        closeModal() {
            this.$refs.presenca.close('')
        },
        takePicture(){
            let video = this.$refs.webCamera
            let canvas = document.createElement('canvas')
            canvas.height = 250
            canvas.width = 250
            let ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            this.pictureData = canvas.toDataURL('image/jpeg');
            this.$refs.picturetaken.src = this.pictureData
            fetch('https://ws.novocfc.com.br/api/v1/ead/foto', {
                method: "POST",
                headers: {
                        "Content-Type": "application/json",
                },
                body: JSON.stringify({
                        tempo: '',
                        turma: this.agrupamento.agrupamento,
                        image: this.pictureData,
                        entidade: this.agrupamento.instrutor ?   'INSTRUTOR' :   'ALUNO',
                        id: localStorage.id,
                        schema: localStorage.schema,
                }),
            })
            .then((response) => {
                this.$toasted.show("Foto de presença registrada com sucesso", {
                    icon: 'fa-check',
                    position: 'top-right',
                    duration: 5000,
                    fullWidth: false
                })
                this.clearPhoto();
                this.closeModal()
            })
        },
        loadCamera(){
            var video = this.$refs.webCamera
            video.setAttribute('autoplay', '')
            video.setAttribute('muted', '')
            video.setAttribute('playsinline', '')
            if(navigator.mediaDevices.getUserMedia)
            {
            navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
            .then((stream) => {
                video.srcObject = stream;
            })
            .catch((error) => {
                alert("Acesso a câmera bloqueado");
            });
            }
        },
        clearPhoto(){
            this.$refs.picturetaken.src = '';
        }
    },
}

</script>
